import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { HttpParams } from '@angular/common/http';
import { RestangularModule, Restangular } from "ngx-restangular";

@Injectable()
export class MapDesignationService {
  private apiUrl = "/api/v1/map-designations"; 
  private apiUrlNew = "https://qhsebe.ilooopsqhse.com/api/v1";

  
  constructor(private restangular: Restangular, private http: HttpClient) {}

  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem("access_token"); // Assuming you store the token in local storage
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return headers;
  }

  getMapDesignations(): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.get(`${this.apiUrl}`, { headers });
  }

  getNewMapDesignations(id: number): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.get(`${this.apiUrl}/${id}`, { headers });
  }





  createMapDesignation(data: any): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.post(`${this.apiUrl}`, data.designation, { headers });
  }


  public addMapDesignation() {
    return this.restangular.all("addMapDesignation");
  }




  updateMapDesignation(id: number, data: any): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.put(`${this.apiUrl}/${id}`, data, { headers });
  }

  deleteMapDesignation(id: number): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.delete(`${this.apiUrl}/${id}`, { headers });
  }







  public getMapDesig(id) {
    return this.restangular.one("getMapDesig/" + id);  
  }

  public getMapAssessmentAssessor(id) {
    return this.restangular.one("getMapAssessmentAssessor/" + id);  
  }

}



// WEBPACK FOOTER //
// /app/src/app/services/mapdesignation.service.ts